import { TRAVEL_RULE_SECURE_PII_EXCHANGE_SECTION } from '@services/permissions/sets'

import type { Section } from '../types'

export const travelRuleSecurePIICollection: Section = {
  label: 'layout:page.travelRule.spe.collection',
  route: '/travel-rule/spe/[linkId]/collection',
  permissions: TRAVEL_RULE_SECURE_PII_EXCHANGE_SECTION,
  segment: {
    page: 'Travel Rule - Secure PII Exchange - Collection',
  },
}

export const travelRuleSecureViewSharedPII: Section = {
  label: 'layout:page.travelRule.spe.viewSharedPii',
  route: '/travel-rule/spe/[linkId]/view-shared',
  permissions: TRAVEL_RULE_SECURE_PII_EXCHANGE_SECTION,
  segment: {
    page: 'Travel Rule - Secure PII Exchange - View Shared PII',
  },
}

export const travelRuleSecurePIIReview: Section = {
  label: 'layout:page.travelRule.spe.initialReview',
  route: '/travel-rule/spe/[linkId]/review',
  permissions: TRAVEL_RULE_SECURE_PII_EXCHANGE_SECTION,
  segment: {
    page: 'Travel Rule - Secure PII Exchange - Initial Review',
  },
}

export const travelRuleSecurePIIDisputeSuccess: Section = {
  label: 'layout:page.travelRule.spe.disputeSuccess',
  route: '/travel-rule/spe/[linkId]/dispute-success',
  permissions: TRAVEL_RULE_SECURE_PII_EXCHANGE_SECTION,
  segment: {
    page: 'Travel Rule - Secure PII Exchange - Dispute Success',
  },
}

export const travelRuleSecurePIILinkExpired: Section = {
  label: 'layout:page.travelRule.spe.linkExpired',
  route: '/travel-rule/spe/[linkId]/link-expired',
  permissions: TRAVEL_RULE_SECURE_PII_EXCHANGE_SECTION,
  segment: {
    page: 'Travel Rule - Secure PII Exchange - Link Expired',
  },
}

export const travelRuleSecurePIIRequestOtp: Section = {
  label: 'layout:page.travelRule.spe.requestOtp',
  route: '/travel-rule/spe/[linkId]/request-otp',
  permissions: TRAVEL_RULE_SECURE_PII_EXCHANGE_SECTION,
  segment: {
    page: 'Travel Rule - Secure PII Exchange - Request OTP',
  },
}

export const travelRuleSecurePIIEnterOtp: Section = {
  label: 'layout:page.travelRule.spe.enterOtp',
  route: '/travel-rule/spe/[linkId]/enter-otp',
  permissions: TRAVEL_RULE_SECURE_PII_EXCHANGE_SECTION,
  segment: {
    page: 'Travel Rule - Secure PII Exchange - Enter OTP',
  },
}

export const travelRuleSecurePIISubmissionSuccess: Section = {
  label: 'layout:page.travelRule.spe.piiSubmissionSuccess',
  route: '/travel-rule/spe/[linkId]/submission-success',
  permissions: TRAVEL_RULE_SECURE_PII_EXCHANGE_SECTION,
  segment: {
    page: 'Travel Rule - Secure PII Exchange - Pii Submission Success',
  },
}

export const travelRuleSectionSecurePIISection: Section = {
  label: 'layout:page.travelRule.spe.title',
  route: '/travel-rule/spe/[linkId]',
  permissions: TRAVEL_RULE_SECURE_PII_EXCHANGE_SECTION,
  pages: [
    travelRuleSecureViewSharedPII,
    travelRuleSecurePIICollection,
    travelRuleSecurePIIReview,
    travelRuleSecurePIIDisputeSuccess,
    travelRuleSecurePIILinkExpired,
    travelRuleSecurePIIRequestOtp,
    travelRuleSecurePIIEnterOtp,
    travelRuleSecurePIISubmissionSuccess,
  ],
  segment: {
    page: 'Travel Rule - Secure PII Exchange',
  },
}
